import React from "react";
import cx from "classnames";
import Wrapper from "./fieldWell.styles";

const FieldWell = ({children, className}) => {
  
  return (
    <Wrapper className={cx("field-well", className)}>
      {children}
    </Wrapper>
  )
};

export default FieldWell;